import { Component, Input } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Observable, of } from 'rxjs';
import { TaskListCharacteristic, TaskListOperation } from 'src/app/models/domain';
import { CharacteristicService } from 'src/app/state';
import { CharacteristicLongTextDialogComponent } from './characteristic-long-text-dialog/characteristic-long-text-dialog.component';

@Component({
  selector: 'em-characteristics-table',
  templateUrl: './characteristics-table.component.html',
  standalone: false,
})
export class CharacteristicsTableComponent {
  public readonly trackByRef = trackByRef;
  public characteristics$ = new Observable<TaskListCharacteristic[]>();

  @Input() public parentId!: string;
  @Input() public loading = false;

  private taskListOperationValue?: TaskListOperation;

  public constructor(
    private readonly characteristicService: CharacteristicService,
    private readonly modalService: NzModalService
  ) {}

  @Input() public set taskListOperation(taskListOperation: TaskListOperation | undefined) {
    this.taskListOperationValue = taskListOperation;

    this.characteristics$ = this.taskListOperationValue
      ? this.characteristicService.selectByOperation(this.taskListOperationValue)
      : of([]);
  }

  public get taskListOperation() {
    return this.taskListOperationValue;
  }

  public showLongText({
    client,
    plant,
    masterInspectionCharacteristics,
    mkVersion,
  }: TaskListCharacteristic) {
    const modalRef = this.modalService.create({
      nzContent: CharacteristicLongTextDialogComponent,
      nzData: {
        client,
        masterInspectionCharacteristics,
        mkVersion,
        plant,
      },
      nzFooter: [
        {
          label: 'Close',
          onClick: () => {
            modalRef.destroy();
          },
        },
      ],
      nzMaskClosable: true,
      nzTitle: 'Long text',
      nzWidth: '80%',
    });
  }
}
